import PropTypes from 'prop-types';
import './MediaCard.css';

export default function MediaCard({
  mediaSrc,
  mediaType = 'image',
  title,
  onClick,
  class_Name = '',
  // Custom font size override configurations (Optional)
  titleSizes = { mobile: '8vmax', sm: '8vmax', md: '6vmax', lg: '8vmin' }
}) {
  const isClickable = Boolean(onClick);

  // Combine dimensions and responsive text configs into inline CSS variables
  const cardStyle = {

    '--title-size-mobile': titleSizes.mobile,
    '--title-size-sm': titleSizes.sm,
    '--title-size-md': titleSizes.md,
    '--title-size-lg': titleSizes.lg,
  };

  return (
    <div
      onClick={onClick}
      style={cardStyle}
      className={`media-card ${class_Name} ${isClickable ? 'clickable' : ''}`}
    >
      {/* Background Media */}
      <div className="media-card-background">
        {mediaType === 'video' ? (
          <video src={mediaSrc} autoPlay loop muted playsInline />
        ) : (
          <img src={mediaSrc} alt={title} />
        )}
      </div>

      {/* Text Backdrop Overlay */}
      <div className="media-card-overlay" />

      {/* Centered Foreground Title */}
      <div className="media-card-content">
        <h2 className="media-card-title">{title}</h2>
      </div>
    </div>
  );
}

MediaCard.propTypes = {
  mediaSrc: PropTypes.string.isRequired,
  mediaType: PropTypes.oneOf(['image', 'video']),
  title: PropTypes.string.isRequired,
  // width: PropTypes.string,  // e.g., '100%', '400px', '25rem'
  // height: PropTypes.string, // e.g., '300px', '50vh', '20rem'
  onClick: PropTypes.func,
  titleSizes: PropTypes.shape({
    mobile: PropTypes.string,
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
  }),
};
